// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2SDwu","log":"ModalInventoryLogs_log__37sZF","date":"ModalInventoryLogs_date__3QAdP","userName":"ModalInventoryLogs_userName__1Ilcs"};